export enum PlanningPoolAction {
  ADD_TO_SHIPMENT = 'ADD_TO_SHIPMENT',
  CREATE_SHIPMENT = 'CREATE_SHIPMENT',
  REMOVE_FROM_PLANNING_POOL = 'REMOVE_FROM_PLANNING_POOL',
  REMOVE_FROM_SHIPMENT = 'REMOVE_FROM_SHIPMENT',
}
